import React from 'react';
import { Link } from 'react-router-dom';
import { FaComment, FaClock, FaEye } from 'react-icons/fa';
import { formatTimeAgo, stripHtml } from '../../../utils/communityUtils';
import CommunityBadge from './CommunityBadge';
import UpvoteButton from './UpvoteButton';

export default function ThreadCard({ thread }) {
  const snippet = stripHtml(thread.contentHtml).substring(0, 150) + '...';
  const hasImage = thread.imageUrls && thread.imageUrls.length > 0;
  const firstImage = hasImage ? thread.imageUrls[0] : null;

  return (
    <div className="community-card p-0 mb-4 ig-style-card">
      {/* Header */}
      <div className="d-flex align-items-center p-3">
        <div 
          className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 text-dark me-3"
          style={{ width: '42px', height: '42px', fontWeight: 'bold', fontSize: '1.2rem', backgroundColor: '#e0e0e0' }}
        >
          {thread.authorName ? thread.authorName.charAt(0).toUpperCase() : 'U'}
        </div>
        <div className="d-flex flex-column flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <Link to={`/community/user/${thread.authorId}`} className="text-white fw-bold text-decoration-none hover-gold ig-username">
              {thread.authorName}
            </Link>
            {thread.authorCommunityRole && <CommunityBadge role={thread.authorCommunityRole} />}
          </div>
          <div className="text-muted d-flex align-items-center gap-2" style={{ fontSize: '0.8rem' }}>
            {thread.lakeId && (
              <span className="text-warning fw-bold">
                {thread.lakeId.replace('lake_', '').replace(/_/g, ' ').toUpperCase()}
              </span>
            )}
            {thread.lakeId && <span className="text-secondary">•</span>}
            <span className="text-light">{formatTimeAgo(thread.createdAt)}</span>
          </div>
        </div>
      </div>

      {/* Image (if exists) */}
      {firstImage && (
        <div className="ig-card-image-container clickable d-flex justify-content-center" onClick={() => window.location.href = `/community/thread/${thread.id}`}>
          <img src={firstImage} alt="Post" className="img-fluid object-fit-contain w-100" style={{ maxHeight: '500px' }} />
        </div>
      )}

      {/* Body / Actions */}
      <div className="p-3">
        {/* Action Buttons */}
        <div className="d-flex align-items-center gap-3 mb-3">
          <UpvoteButton 
            discussionId={thread.id} 
            initialCount={thread.upvoteCount} 
            layout="horizontal"
          />
          <Link to={`/community/thread/${thread.id}`} className="btn btn-sm d-flex align-items-center gap-1 border-0 ig-action-btn text-decoration-none">
            <FaComment className="fs-5" /> <span className="fw-bold">{thread.replyCount || 0}</span>
          </Link>
          <div className="btn btn-sm d-flex align-items-center gap-1 border-0 ms-auto ig-action-btn text-decoration-none" style={{cursor: 'default'}}>
            <FaEye className="fs-5" /> <span className="fw-bold">{thread.viewCount || 0}</span>
          </div>
        </div>

        {/* Title & Caption */}
        <div className="mb-1">
          <Link to={`/community/thread/${thread.id}`} className="text-white fw-bold me-2 text-decoration-none hover-gold ig-title">
            {thread.title}
          </Link>
        </div>
        
        <div className="text-light ig-caption mb-2" style={{ fontSize: '0.95rem', lineHeight: '1.4' }}>
          <span className="fw-bold me-2 text-white">{thread.authorName}</span>
          <span className="text-light">{snippet}</span>
          <Link to={`/community/thread/${thread.id}`} className="text-warning ms-1 text-decoration-none hover-gold">
            more
          </Link>
        </div>
        
        {/* View all comments link */}
        {thread.replyCount > 0 && (
          <Link to={`/community/thread/${thread.id}`} className="text-warning text-decoration-none hover-gold fw-bold" style={{ fontSize: '0.9rem' }}>
            View all {thread.replyCount} comments
          </Link>
        )}
      </div>
    </div>
  );
}
